import React from 'react';
import { EventInterface } from './FutureEvents';

interface NextEventInterface {
    nextEvent?: EventInterface;
};

function NextEvent({nextEvent}: NextEventInterface) {
    const eventImg = require("../images/coffeeshop.png");
    return (
        <div className="nextEventWrapper">
            <div className="nextEventDateWrapper">
                <div className="nextEventRedDot"></div>
                <div className="nextEventDate">{nextEvent?.timeText}</div>
            </div>
            <div className="nextEventContentAndImageWrapper">
                <img className="nextEventImage" src={eventImg} alt="event"/>
                <div className="nextEventContentWrapper">
                    <div className="nextEventTopWrapper">
                        <div className="nextEventLocation">{nextEvent?.location}</div>
                        <div className="nextEventTitle">{nextEvent?.name}</div>
                    </div>
                    <div className="nextEventBottomWrapper">
                        <div className="nextEventDescription">{nextEvent?.description}</div>
                        <button className="nextEventDetailsButton">EVENT DETAILS</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NextEvent;